import _ from 'lodash'
import type {DalItem, DocumentManager} from '@wix/document-manager-core'
import type {Experiment} from '@wix/document-services-types'
import type {PageMigrator} from '../dataMigrationRunner'

const styleTypesToFix = ['ComponentStyle', 'TopLevelStyle']
const experimentName = 'dm_fixComponentStyleProperties'

const isStyleTypeToFix = (type?: string) => _.includes(styleTypesToFix, type)
const isStyleProperties = (properties: unknown): properties is Record<string, unknown> => _.isPlainObject(properties)
const isValidStylePropertyValue = (value: unknown) => _.isString(value) || _.isNumber(value) || _.isBoolean(value)

const hasInvalidStyleProperties = (styleItem: DalItem) => {
    const properties = styleItem.style?.properties

    return (
        isStyleTypeToFix(styleItem.type) &&
        isStyleProperties(properties) &&
        _.some(properties, property => !isValidStylePropertyValue(property))
    )
}

const migratePage = (documentManager: DocumentManager, pageId: string, experimentInstance: Experiment) => {
    if (!experimentInstance.isOpen(experimentName)) {
        return
    }

    const {dal, pointers} = documentManager
    const stylePointers = pointers.data.getStyleItemsWithPredicate(hasInvalidStyleProperties, pageId)

    _.forEach(stylePointers, pointer => {
        const styleItem = dal.get(pointer)
        const fixedProperties = _.pickBy(styleItem.style.properties, isValidStylePropertyValue)

        dal.set(pointer, {
            ...styleItem,
            style: {
                ...styleItem.style,
                properties: fixedProperties
            }
        })
    })
}

const name = 'fixComponentStyleProperties'
const version = 2
const experimentalVersions = [{experiment: experimentName, version: 3}]

export const fixComponentStyleProperties: PageMigrator = {
    migratePage,
    name,
    version,
    experimentalVersions
}
